<div class="cont-base {{additionalClass}}" [class.error]="isError" [class.touched]="isTouched" [class.open]="isOpen" (click)="toggleShowOptions()"
  (clickOutside)="clickOutSide()">
  <div class="select-filter">
    <div class="select-default">
      <span 
        class="title {{additionalClassTitle}}" 
        [class.chosen-option]="isChosenOption">
        {{ title | cuttext: cutTextLength}}
        {{ currentChapter?.name }}
      </span>
      <i 
        class="iconlace iconlace-chevron-down {{additionalClassIcon}}" 
        [class.error]="isError"
        [@rotateAnimation]="isOpen ? 'up' : 'down'">
      </i>
      <i 
        *ngIf="enableClearOption && isChosenOption"
        class="iconlace iconlace-cross {{additionalClassIcon}}"  
        (click)="clear()">
      </i>
    </div>
    <div class="select-wrapper" *ngIf="isOpen">
      <ng-container *ngIf="enableCategory">
        <div *ngIf="isCompleteBible && viewMode === 'books'" class="category">
          <ng-container *ngFor="let category of listCategory">
            <div 
              class="category-item" 
              [ngClass]="{'active': category.id == currentCategory?.value}"
              (click)="sendCategory(category);
              $event.stopPropagation()"
            >
              <img *ngIf="category.image" class="category-country" [src]="category.image">
              <span class="category-name">{{category.nameLocal}}</span>
            </div>
          </ng-container>
        </div>
      </ng-container>
      
      <div class="select-option">
        <div *ngIf="viewMode === 'books'" class="ebook-nav">
          <ng-container [ngTemplateOutlet]="listOption"></ng-container>
        </div>
        
        <div *ngIf="viewMode === 'chapters'" class="ebook-list">
          <ng-container [ngTemplateOutlet]="listSubOption"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #listOption>
  <ng-container *ngFor="let item of optionList; let i = index">
    <div 
      class="select-item" 
      [ngClass]="{'active': item.value == currentValue?.value}" 
      (click)="sendOption(item); 
      $event.stopPropagation()"
    >
      <span>{{item.name.toString() | translate }}</span>
      <i *ngIf="item.value === currentBookWithChapters && !show"
        class="iconlace iconlace-chevron-next {{additionalClassIcon}}"
        (click)="toggleShowSubItem(i);
        $event.stopPropagation()">
      </i>
    </div>
  </ng-container>
</ng-template>

<ng-template #listSubOption>
  <div class="select-sub-item">
    <div (click)="goBackToBooks(); $event.stopPropagation()" class="select-sub-item-header">
      <i class="iconlace iconlace-chevron-previous"></i>
      <span>{{ title }}</span>
    </div>
    <div class="select-sub-item-reference">
      <ng-container *ngFor="let item of listChapter">
        <span 
          (click)="filterChapter(item)"
          [ngClass]="{'active-chapter': item.id == currentChapter?.value}" 
        >
          {{item.number}}
        </span>
      </ng-container>
    </div>
  </div>
</ng-template>